/**
 * Standalone URL helpers with no natural home in `api/` (not a backend call)
 * or `components/` (not a component). See `frontend/CLAUDE.md` §2 for what
 * `lib/` is for.
 */

/** True when `url` parses as an absolute http(s) URL.
 *
 * Defense-in-depth (PIVOT-114): `absolute_url` (backend/src/pivot/scrapers/base.py)
 * now refuses to resolve a non-http(s) scheme at scrape time, but a row already
 * in the corpus before that landed can still carry whatever a hostile posting's
 * `javascript:`/`data:` href resolved to, unrelated to `match.job.url` — and
 * `<a href>` executes a `javascript:` URL in the candidate's own session on
 * click. Checked here too, not only at ingestion. Used by both `MatchCard`
 * (dashboard) and `MatchListRow` (`/saved`, PIVOT-132) — the latter is
 * specifically where *old* score rows surface, exactly the pre-guard corpus
 * this check exists for. Do not widen the allowlist: that is how this class
 * of bug returns.
 */
export function isHttpUrl(url: string): boolean {
  try {
    const { protocol } = new URL(url)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}
